import {
  CheckoutDirectDebitAccountDetails,
  CheckoutDirectDebitIbanAccountDetails,
  CheckoutDirectDebitPaymentDetails,
  DirectDebitFormValue,
} from '@checkout/util-models';
import { PaymentType, removeNullValues } from '@domgen/dgx-fe-common';

export function formatDirectDebitFormValueToPaymentDetails(
  formValue: DirectDebitFormValue
): CheckoutDirectDebitPaymentDetails | undefined {
  formValue = removeNullValues(formValue);

  if (!formValue.paymentDate) {
    return undefined;
  }

  if (formValue.paymentToken) {
    return {
      directDebitPaymentToken: formValue.paymentToken,
      paymentType: PaymentType.DirectDebit,
      preferredPaymentDay: Number(formValue.paymentDate),
    };
  }

  return {
    paymentType: PaymentType.DirectDebit,
    directDebitDetails:
      formatDirectDebitFormValueToDirectDebitDetails(formValue),
    preferredPaymentDay: Number(formValue.paymentDate),
  };
}

export function formatDirectDebitFormValueToDirectDebitDetails(
  formValue: DirectDebitFormValue
): CheckoutDirectDebitAccountDetails | CheckoutDirectDebitIbanAccountDetails {
  if (formValue.iban) {
    return {
      accountName: formValue.accountName ?? '',
      iban: formValue.iban.toUpperCase(),
    };
  }

  return {
    accountName: formValue.accountName ?? '',
    accountNumber: formValue.accountNumber?.toString() ?? '',
    sortCode: formValue.sortCode?.toString() ?? '',
  };
}

export function formatDirectDebitPaymentDetailsToFormValue(
  paymentDetails?: CheckoutDirectDebitPaymentDetails
): DirectDebitFormValue | undefined {
  if (!paymentDetails) {
    return undefined;
  }

  const { preferredPaymentDay, directDebitDetails, directDebitPaymentToken } =
    paymentDetails;

  if (directDebitPaymentToken) {
    return {
      accountHolderConfirmation: true,
      accountName: null,
      accountNumber: null,
      iban: null,
      paperlessPreference: false,
      paymentDate: preferredPaymentDay,
      paymentToken: directDebitPaymentToken,
      sortCode: null,
      termsAndConditions: true,
    };
  }

  if (!directDebitDetails) {
    return undefined;
  }

  if ('iban' in directDebitDetails) {
    return {
      accountHolderConfirmation: true,
      accountName: directDebitDetails.accountName,
      accountNumber: null,
      iban: directDebitDetails.iban.toUpperCase(),
      paperlessPreference: false,
      paymentDate: preferredPaymentDay,
      sortCode: null,
      termsAndConditions: true,
      paymentToken: null,
    };
  }

  return {
    accountHolderConfirmation: true,
    accountName: directDebitDetails.accountName,
    accountNumber: directDebitDetails.accountNumber,
    iban: null,
    paperlessPreference: false,
    paymentDate: preferredPaymentDay,
    sortCode: directDebitDetails.sortCode,
    termsAndConditions: true,
    paymentToken: null,
  };
}
